function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowntrendArrowOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 12.5L9.00008 6.16667L5.66675 9.5L0.666748 4.5",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.5H15.3333V8.5",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntrendArrowOrange);
export default __webpack_public_path__ + "static/media/downtrend-arrow-orange.f668e74120584395295fba82b0e8c30b.svg";
export { ForwardRef as ReactComponent };